import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const CategoriesMenu = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [visibleCategories, setVisibleCategories] = useState(9);
  const menuRef = useRef(null);

  const [dataCategories, setDataCategories] = useState([]);
  const [dataSubCategories, setDataSubCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://laravel-api.aj-mart.com/api/categories');
        setDataCategories(response.data.category);
        setActiveCategory(response.data.category[0]);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (activeCategory) {
      const fetchSubCategories = async () => {
        try {
          const response = await axios.get('https://laravel-api.aj-mart.com/api/subCategory');
          const filteredSubCategories = response.data.sub_category.filter(
            (sub) => sub.sub_category_main_name === activeCategory.category_name_E
          );
          setDataSubCategories(filteredSubCategories);
        } catch (error) {
          console.error('Error fetching subcategories:', error);
        }
      };
      fetchSubCategories();
    }
  }, [activeCategory]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleShowMore = () => {
    setVisibleCategories((prev) => prev + 5);
  };

  const getLocalizedText = (key) => (i18n.language === 'ar' ? key.A : key.E);

  // helper to slugify subcategory name (مثل ما عامل بصفحة MainCategories)
  const slugify = (s) => s.replace(/\s+/g, '-');

  return (
    <div className="group" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="font-bold transition duration-500 text-[#666666]"
      >
        {t('Categories')}
      </button>

      {isOpen && (
        <div className="absolute top-[133px] left-0 mt-2 w-screen bg-white shadow-xl z-50 rounded-b-lg">
          <div className="max-w-7xl mx-auto flex min-h-[400px]">
            {/* Categories Column */}
            <div className="border-right-none w-[20%] border-r border-gray-200 py-4">
              <div className="font-bold text-[22px]">{t('Main Category')}</div>
              {dataCategories.slice(0, visibleCategories).map((category) => (
                <Link
                  to={`/mainCategories/${encodeURIComponent(category.category_name_E)}`}
                  key={category.category_id}
                  onMouseEnter={() => setActiveCategory(category)}
                  onClick={() => setIsOpen(false)}
                  className={`py-3 cursor-pointer flex items-center justify-between ${
                    activeCategory && activeCategory.category_id === category.category_id
                      ? 'bg-[#1485a61a] text-[#1485a6]'
                      : 'hover:bg-[#1485a61a]'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={`https://laravel-api.aj-mart.com/storage/app/public/${category.category_img}`}
                      alt={category.category_name_E}
                      className="w-8 h-8 object-contain rounded"
                    />
                    <span>
                      {getLocalizedText({
                        A: category.category_name_A,
                        E: category.category_name_E,
                      })}
                    </span>
                  </div>
                </Link>
              ))}
              {visibleCategories < dataCategories.length && (
                <button
                  onClick={handleShowMore}
                  className="text-[#1485a6] py-2 px-4 mt-4 block border border-[#1485a6] rounded-md hover:bg-[#1485a6] hover:text-white transition-colors"
                >
                  {t('Show More')}
                </button>
              )}
            </div>

            {/* Subcategories Column */}
            <div className="w-[80%] p-6 bg-white">
              {activeCategory && (
                <>
                  <div className="flex items-center gap-4 mb-6">
                    <img
                      src={`https://laravel-api.aj-mart.com/storage/app/public/${activeCategory.category_img}`}
                      alt={activeCategory.category_name_E}
                      className="w-12 h-12 object-contain rounded"
                    />
                    <h3 className="text-lg font-semibold text-[#1485a6]">
                      {getLocalizedText({
                        A: activeCategory.category_name_A,
                        E: activeCategory.category_name_E,
                      })}
                    </h3>
                  </div>
                  <div className="grid grid-cols-4 gap-4">
                    {dataSubCategories.map((subcategory, index) => {
                      const subLocalized = getLocalizedText({
                        A: subcategory.sub_category_name_A,
                        E: subcategory.sub_category_name_E,
                      });
                      const mainSlug = encodeURIComponent(activeCategory.category_name_E);
                      const subSlug = encodeURIComponent(slugify(subLocalized));

                      return (
                        <Link
                          key={index}
                          // ✅ نفس نمط الرابط المستخدم بصفحة MainCategories
                          to={`/subCategories/${mainSlug}/${subSlug}`}
                          className="text-gray-600 hover:text-[#1485a6] transition-colors py-2"
                          onClick={() => setIsOpen(false)}
                        >
                          {subLocalized}
                        </Link>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoriesMenu;
